module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    class: _vm.wrapClasses,
    on: {
      "click": _vm.toggle
    }
  }, [_c('span', {
    class: _vm.innerClasses
  }, [(_vm.currentValue) ? _vm._t("open") : _vm._e(), _vm._v(" "), (!_vm.currentValue) ? _vm._t("close") : _vm._e()], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-241c612a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/iview/src/components/switch/switch.vue
// module id = 604
// module chunks = 1